import { FormBase } from 'core/components';

export default class CreateBoxForm extends FormBase {
	constructor(hooks) {
		super(hooks);
	}
	setup() {
		return {
			fields: [
				{
					name: 'name',
					label: 'LOOKUP.BOX.NAME',
					rules: 'required|string',
				},
				{
					name: 'boxHeight',
					label: 'LOOKUP.BOX.HEIGHT',
					rules: 'required|integer',
				},
				{
					name: 'boxWidth',
					label: 'LOOKUP.BOX.WIDTH',
					rules: 'required|integer',
				},
				{
					name: 'boxLength',
					label: 'LOOKUP.BOX.LENGTH',
					rules: 'required|integer',
				},
			],
		};
	}
}



// WEBPACK FOOTER //
// ./src/modules/product/forms/CreateBoxForm.js